import deepmerge from 'deepmerge'
import { makeColors } from './utils'

// Old(current) colors
const colorsOld = {
  light: {
    oee: '#0ea5e9',
    availability: '#10b981',
    performance: '#f59e0b',
    quality: '#ef4444',
    production: '#26a69a',
    downtime: '#f44336',
    changeover: '#2196f3',
    inactive: '#9e9e9e',
    goodPart: '#26a69a',
    badPart: '#d32f2f',
    metrics: {
      high: '#66bb6a',
      medium: '#ffa726',
      low: '#f44336',
    },
  },
  dark: {
    oee: '#0ea5e9',
    availability: '#10b981',
    performance: '#f59e0b',
    quality: '#ef4444',
    production: '#26a69a',
    downtime: '#f44336',
    changeover: '#2196f3',
    inactive: '#9e9e9e',
    goodPart: '#26a69a',
    badPart: '#d32f2f',
    metrics: {
      high: '#66bb6a',
      medium: '#ffa726',
      low: '#f44336',
    },
  },
}

// Colors used in the mobile app
const colorsMobileApp = {
  light: {
    production: '#48BB55',
    downtime: '#DB504A',
    changeover: '#3894db',
    badPart: '#9B51E0',
    plannedDowntime: '#6f8676',
    changeoverDowntime: '#3f96a5',
    shutdown: '#8f8f8f',
  },
  dark: {
    production: '#237540',
    downtime: '#d6463e',
    changeover: '#27638C',
    badPart: '#8651bb',
    plannedDowntime: '#2e4634',
    changeoverDowntime: '#1b525c',
    shutdown: '#8f8f8f',
  },
}

// Merged colors
const colorsMerged = {
  light: deepmerge(colorsOld.light, colorsMobileApp.light),
  dark: deepmerge(colorsOld.dark, colorsMobileApp.dark),
}

export const colors = {
  light: makeColors({ oee: colorsMerged.light }),
  dark: makeColors({ oee: colorsMerged.dark }),
}

declare module '@mui/material/styles' {
  interface Palette {
    oee: {
      oee: string
      availability: string
      performance: string
      quality: string
      production: string
      downtime: string
      changeover: string
      shutdown: string
      plannedDowntime: string
      inactive: string
      goodPart: string
      badPart: string
      metrics: {
        high: string
        medium: string
        low: string
      }
    }

    'oee-oee': { main: string }
    'oee-availability': { main: string }
    'oee-performance': { main: string }
    'oee-quality': { main: string }
    'oee-production': { main: string }
    'oee-downtime': { main: string }
    'oee-changeover': { main: string }
    'oee-shutdown': { main: string }
    'oee-planned-downtime': { main: string }
    'oee-inactive': { main: string }
    'oee-good-part': { main: string }
    'oee-bad-part': { main: string }
    'oee-metrics-high': { main: string }
    'oee-metrics-medium': { main: string }
    'oee-metrics-low': { main: string }
  }

  interface PaletteOptions {
    oee?: Partial<Palette['oee']>

    'oee-oee'?: Partial<Palette['oee-oee']>
    'oee-availability'?: Partial<Palette['oee-availability']>
    'oee-performance'?: Partial<Palette['oee-performance']>
    'oee-quality'?: Partial<Palette['oee-quality']>
    'oee-production'?: Partial<Palette['oee-production']>
    'oee-downtime'?: Partial<Palette['oee-downtime']>
    'oee-changeover'?: Partial<Palette['oee-changeover']>
    'oee-shutdown'?: Partial<Palette['oee-shutdown']>
    'oee-planned-downtime'?: Partial<Palette['oee-planned-downtime']>
    'oee-inactive'?: Partial<Palette['oee-inactive']>
    'oee-good-part'?: Partial<Palette['oee-good-part']>
    'oee-bad-part'?: Partial<Palette['oee-bad-part']>
    'oee-metrics-high'?: Partial<Palette['oee-metrics-high']>
    'oee-metrics-medium'?: Partial<Palette['oee-metrics-medium']>
    'oee-metrics-low'?: Partial<Palette['oee-metrics-low']>
  }
}

export interface AvailablePropsColorOverrides {
  'oee-oee': true
  'oee-availability': true
  'oee-performance': true
  'oee-quality': true
  'oee-production': true
  'oee-downtime': true
  'oee-changeover': true
  'oee-shutdown': true
  'oee-planned-downtime': true
  'oee-inactive': true
  'oee-good-part': true
  'oee-bad-part': true
  'oee-metrics-high': true
  'oee-metrics-medium': true
  'oee-metrics-low': true
}
